import React from 'react';

import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
  NamedLink,
} from '../../components';

import { FormattedMessage } from '../../util/reactIntl';

import StaticPage from '../../containers/StaticPage/StaticPage';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';

import css from './JobsPage.module.css';
import JobsList from './JobsList';

const JobsPage = () => {

  return (
    <StaticPage
      title="Jobs at AllCourse"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'JobsPage',
        description: 'Jobs at AllCourse',
        name: 'Jobs at AllCourse',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>

          <div className={css.hero}>
            <h1 className={css.heroTitle}>
              <FormattedMessage id="JobsPage.title" />
            </h1>

          </div>
          <div className={css.container}>
            <JobsList />
            <NamedLink name="AboutPage" className={css.jobsButton}>
              <FormattedMessage id="JobsPage.buttonText" />
            </NamedLink>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default JobsPage;
